<template>
  <div class="quest_banner flex">
	   <el-carousel :interval="5000" arrow="never">
	      <el-carousel-item v-for="item in 4" :key="item">
	        <img src="../../../assets/claim/videoclaim_sample.png" >
	      </el-carousel-item>
	    </el-carousel>
	  
    <div class="form flex_start">
      <div class="b_form">
        <div class="title flex_start">
          <img src="~assets/question/b_form_ic.png" /> 在线问律师
        </div>
        <div class="in">
          <textarea
            placeholder="请在此描述您的问题，尽量详细，有利于律师分析您的问题！"
          ></textarea>
        </div>
        <div class="submit">提交问题</div>
        <div class="bt between">
          <div>律师在线<span class="w">5500</span>位</div>
          <div>今日解答<span class="t">6186</span>条</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scope >
.quest_banner {
  // background: url("~assets/question/question_banner.png");
  width: 1200px;
  height: 390px;
  margin: 30px auto;
  background-position-y: -1px;
  .el-carousel{
	  width: 820px;
	  height: 390px;
	  .el-carousel__container{
		  width: 100%;
		  height: 100%;
	  }
	  img{
		  width: 100%;
		  height: 100%;
	  }
  }
  .form {
    // width: 1200px;
    height: 100%;
    margin: 0 auto;
	box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
    .b_form {
      width: 350px;
      padding: 24px;
      background-color: #fff;
      .title {
        margin-top: 10px;
        font-size: 26px;
        color: #0465ea;
        img {
          width: 27px;
          height: 27px;
          margin-right: 12px;
          vertical-align: -0.15em;
        }
      }
      .in {
        width: 100%;
        margin: 30px auto;
        border-bottom: 1px solid #eee;
        textarea {
          font-size: 16px;
          resize: none;
          border: none;
          outline: none;
          width: 100%;
          height: 110px;
        }
      }
      .submit {
        width: 180px;
        height: 44px;
        line-height: 44px;
        color: #fff;
        background: #cb0d0f;
        box-shadow: 0px 1px 10px 0px rgba(173, 0, 2, 0.15);
        border-radius: 5px;
        font-size: 20px;
        text-align: center;
        margin: 0 auto;
        cursor: pointer;
      }
      .bt {
        margin-top: 35px;
        font-size: 16px;
        color: #999999;
        .w {
          color: #0465ea;
        }
        .t {
          color: #cb0d0f;
        }
      }
    }
  }
}
</style>